(() => {
 'use strict';
 const root=document.querySelector('[data-cr-reviews]');
 if(!root || root.dataset.crReady)return;
 root.dataset.crReady='true';
 const loadPhoto=img=>{
  if(img.dataset.crSrcset){img.srcset=img.dataset.crSrcset;delete img.dataset.crSrcset;}
  img.src=img.dataset.crSrc;delete img.dataset.crSrc;
 };
 const photoObserver='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(entry.isIntersecting){loadPhoto(entry.target);photoObserver.unobserve(entry.target);}
 }),{rootMargin:'320px 0px'}):null;
 document.querySelectorAll('img[data-cr-src]').forEach(img=>photoObserver?photoObserver.observe(img):loadPhoto(img));

 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const cards=[...root.querySelectorAll('[data-cr-card]')];
 const entered=new WeakSet();
 const enter=node=>{
  if(entered.has(node))return;entered.add(node);
  if(!matchMedia('(max-width:899px)').matches&&!reduced.matches&&!document.hidden)node.animate?.([{opacity:.12,transform:'translateY(14px)'},{opacity:1,transform:'none'}],{duration:420,easing:'cubic-bezier(.2,.72,.25,1)'});
 };
 const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){enter(e.target);observer.unobserve(e.target);}}),{threshold:.08}):null;

 const pageSize=20;
 const more=root.querySelector('[data-cr-more]'),status=root.querySelector('[data-cr-load-status]');
 let visibleCount=pageSize?Math.min(pageSize,cards.length):cards.length;
 cards.forEach((card,index)=>{card.hidden=index>=visibleCount;if(!card.hidden)observer?.observe(card);});
 if(pageSize&&more){
  more.hidden=visibleCount>=cards.length;
  more.addEventListener('click',()=>{
   const start=visibleCount;visibleCount=Math.min(visibleCount+pageSize,cards.length);
   cards.slice(start,visibleCount).forEach(card=>{card.hidden=false;observer?.observe(card);});
   more.hidden=visibleCount>=cards.length;
   if(status)status.textContent=more.hidden?'Alle Kundenstimmen sind eingeblendet.':`Weitere ${visibleCount-start} Bewertungen eingeblendet.`;
   cards[start]?.querySelector('[data-cr-photo]')?.focus({preventScroll:true});
  });
 }


 const rail=document.querySelector('[data-cr-rail]'),toggle=rail?.querySelector('[data-cr-pause]');
 let paused=reduced.matches,inView=false,photoFocused=false;
 function syncRail(){
  if(!rail)return;
  rail.classList.toggle('is-running',inView&&!paused&&!reduced.matches&&!document.hidden&&!photoFocused);
  rail.classList.toggle('is-static',paused||reduced.matches);
  toggle.setAttribute('aria-pressed',String(paused||reduced.matches));
  toggle.setAttribute('aria-label',paused||reduced.matches?'Fotobewegung starten':'Fotobewegung anhalten');
  toggle.textContent=paused||reduced.matches?'▶':'Ⅱ';
 }
 let railObserver;
 if(rail){
  rail.classList.add('is-enhanced');toggle.hidden=false;
  toggle.addEventListener('click',()=>{paused=!paused;syncRail();});
  rail.addEventListener('focusin',event=>{photoFocused=event.target.matches('[data-cr-photo]');syncRail();});
  rail.addEventListener('focusout',()=>{photoFocused=false;syncRail();});
  if('IntersectionObserver'in window){railObserver=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;syncRail();},{threshold:.01});railObserver.observe(rail);}
  else{paused=true;syncRail();}
 }
 reduced.addEventListener('change',()=>{if(reduced.matches)paused=true;syncRail();});
 document.addEventListener('visibilitychange',syncRail);

 const dialog=document.querySelector('[data-cr-dialog]'),data=document.querySelector('[data-cr-gallery]');
 let gallery=[];try{gallery=JSON.parse(data.textContent);}catch{return;}
 const full=dialog.querySelector('[data-cr-full]'),caption=dialog.querySelector('[data-cr-caption]'),position=dialog.querySelector('[data-cr-position]');
 let current=0,returnFocus=null,priorOverflow='';
 function showPhoto(index){
  current=(index+gallery.length)%gallery.length;const photo=gallery[current];
  full.src=photo.url+'&width=1200';full.alt=photo.alt;
  caption.textContent=photo.author;position.textContent=`Foto ${current+1}`;
 }
 document.querySelectorAll('[data-cr-photo]').forEach(button=>button.addEventListener('click',()=>{
  returnFocus=button;showPhoto(Number(button.dataset.crPhoto));
  if(!dialog.showModal)return;
  priorOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();
 }));
 dialog.querySelector('[data-cr-close]').addEventListener('click',()=>dialog.close());
 dialog.querySelector('[data-cr-prev]').addEventListener('click',()=>showPhoto(current-1));
 dialog.querySelector('[data-cr-next]').addEventListener('click',()=>showPhoto(current+1));
 dialog.addEventListener('keydown',event=>{
  if(event.key==='ArrowRight'){event.preventDefault();showPhoto(current+1);}
  if(event.key==='ArrowLeft'){event.preventDefault();showPhoto(current-1);}
 });
 dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
 dialog.addEventListener('close',()=>{document.body.style.overflow=priorOverflow;returnFocus?.focus({preventScroll:true});});
 window.addEventListener('pagehide',()=>{rail?.classList.remove('is-running');if(dialog.open)dialog.close();});
 window.addEventListener('pageshow',syncRail);
})();
